import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import colors from 'Common/constants/colors';
import { css } from 'styled-components';
import { ifProp } from 'styled-tools';

const Wrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background: ${colors.DARKEST_GRAY};

    @media screen and (min-width: 580px) {
        width: 320px;
    }
`;

const Slide = styled.button`
    display: block;
    width: 100%;
    padding: 10px 20px;
    background: none;
    border: 0 none;
    color: ${colors.LIGHT_GRAY};
    text-align: left;
    cursor: default !important;

    &:hover,
    &:focus {
        outline: 0 none;
    }

    ${ifProp(
        'isAvailable',
        css`
            color: ${colors.WHITE};
            cursor: pointer !important;

            &:hover,
            &:focus {
                background: ${colors.DARKEST_GRAY};
                color: ${colors.WHITE};
            }
        `,
    )}

    ${ifProp(
        'isActive',
        css`
            color: ${colors.ORANGE};

            &:hover,
            &:focus {
                color: ${colors.ORANGE};
            }
        `,
    )}
`;

const SlidesSidebarMenu = ({
    elementRef,
    slides,
    slideNumber,
    maxAvailableSlideNumber,
    onSlideNumberChange,
}) => (
    <Wrapper ref={elementRef}>
        {slides.map((slide, index) => {
            const number = index + 1;
            const isActive = number === slideNumber;
            const isAvailable = number <= maxAvailableSlideNumber && !isActive;

            return (
                <Slide
                    key={slide.id}
                    isAvailable={isAvailable}
                    isActive={isActive}
                    onClick={
                        isAvailable
                            ? () => onSlideNumberChange(number)
                            : undefined
                    }
                >{`${number}. ${slide.title}`}</Slide>
            );
        })}
    </Wrapper>
);

SlidesSidebarMenu.propTypes = {
    slides: PropTypes.array.isRequired,
    slideNumber: PropTypes.number.isRequired,
    maxAvailableSlideNumber: PropTypes.number.isRequired,
    onSlideNumberChange: PropTypes.func.isRequired,
};

export default SlidesSidebarMenu;
